export const SHUTTERSTOCK_API_VERSION = 2;
export const SHUTTERSTOCK_MAX_IMAGES = 5;

export const PAGES_WITHOUT_NAVBAR = [
  "/signup",
  "/verification-code",
  "/setup",
  "/invite-team",
  "/thanks",
  "/registrieren",
  "/onboarding",
  "/login",
  "/password-reset"
];
